import React, {Fragment} from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import succImg from 'static/images/wine-glasses.svg';

export default function ResultBlock(props) {
	function createMarkup() {
		return {__html: props.msg};
	  }
	  
	return (
	<Box bgcolor="white" className="alert-block">
		<Grid container alignItems="center" direction="column" style={{paddingBottom: '40px'}}>
			{props.status === 'succ'
				?
				<Fragment>
					<img src={succImg} width="114" alt="" />
					<Typography color="primary" variant="h2">{props.title}</Typography>
				</Fragment>
				:
				<Fragment>
					<i class="material-icons">warning</i>
					<Typography color="error" variant="h2">{props.title}</Typography>
				</Fragment>
			}
			<Typography style={{textAlign: 'center'}} dangerouslySetInnerHTML={createMarkup()} />
			{!!props.onClick && 
				<Button color="primary" variant="contained" onClick={props.onClick}>前往訂單記錄</Button>
			}
		</Grid>
	</Box>
	)
}
